import React from 'react';
import '@ant-design/v5-patch-for-react-19';
import CalculatorPage from './pages/CalculatorPage';

function App() {
  return (
    <div className="App">
      <CalculatorPage />
    </div>
  );
}

export default App;
